// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProxSubmission } from './prox-submission';
import { ProxSubmissionStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProxSubmissionStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: ProxSubmissionStatusEnum;
  /** String(50) */
  name!: string;
  /** Inv FK proxSubmissionStatusId */
  proxSubmissions!: ProxSubmission[];
}

